export default "__VITE_ASSET__DCKeka6y__"